import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

interface TerminalTextProps {
  finalText: string;
  className?: string;
}

const TerminalText: React.FC<TerminalTextProps> = ({ finalText, className = '' }) => {
  const [displayText, setDisplayText] = useState('');
  const [showCursor, setShowCursor] = useState(true);

  const randomChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()';
  
  useEffect(() => {
    let timeouts: NodeJS.Timeout[] = [];
    
    // First phase: random characters
    for (let i = 0; i < finalText.length; i++) {
      const timeout = setTimeout(() => {
        setDisplayText(prev => {
          const newText = prev + randomChars[Math.floor(Math.random() * randomChars.length)];
          return newText;
        });
      }, i * 50);
      timeouts.push(timeout);
    }

    // Second phase: correct characters one by one
    for (let i = 0; i < finalText.length; i++) {
      const timeout = setTimeout(() => {
        setDisplayText(prev => {
          const chars = prev.split('');
          chars[i] = finalText[i];
          return chars.join('');
        });
      }, finalText.length * 50 + i * 100);
      timeouts.push(timeout);
    }

    // Hide cursor when done
    const finalTimeout = setTimeout(() => {
      setShowCursor(false);
    }, finalText.length * 150 + 1000);
    timeouts.push(finalTimeout);

    return () => {
      timeouts.forEach(timeout => clearTimeout(timeout));
    };
  }, [finalText]);

  return (
    <div className={`font-orbitron ${className}`}>
      <span className="cyber-glow-strong">{displayText}</span>
      {showCursor && (
        <motion.span
          animate={{ opacity: [1, 0] }}
          transition={{ duration: 0.5, repeat: Infinity }}
          className="text-green-400"
        >
          ▌
        </motion.span>
      )}
    </div>
  );
};

export default TerminalText;